import React, { useRef, useEffect, useState, memo } from "react";

import * as SC from "./Card.styled";
import CardHeader from "./CardHeader/CardHeader";
import AttentionBox from "../AttentionBox/AttentionBox";

const Card = memo(
  ({
    cardKey = "",
    title,
    channels = [],
    options = [],
    showWinner,
    expandAttentionBox,
    fullWidth,
    children,
    display = true,
    wrapperHeight
  }) => {
    const contentWrapperRef = useRef(null);
    const childrenRef = useRef(null);

    const [contentHeight, setContentHeight] = useState({ wrapper: 0, children: 0 });

    useEffect(() => {
      const newContentHeight = {
        wrapper: contentWrapperRef.current?.scrollHeight || 0,
        children: childrenRef.current?.scrollHeight || 0
      };

      setContentHeight(newContentHeight);
    }, [children]);

    return (
      <SC.CardWrapper
        expanded={expandAttentionBox}
        fullWidth={fullWidth}
        wrapperHeight={wrapperHeight || contentHeight.wrapper}
        key={cardKey}
        style={{ display: display ? "flex" : "none" }}
      >
        <SC.ContentWrapper ref={contentWrapperRef}>
          <CardHeader
            cardKey={cardKey}
            title={title}
            channels={channels}
            options={options}
            showWinner={showWinner}
          />
          <SC.Divider />
          <SC.Children ref={childrenRef}>{children}</SC.Children>
        </SC.ContentWrapper>
        <AttentionBox expanded={expandAttentionBox} cardKey={cardKey} />
      </SC.CardWrapper>
    );
  }
);

Card.displayName = "Card";
export default Card;
